
import { updateAppConfig } from '#app'
import { defuFn } from '/opt/build/repo/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "firebaseConfig": {
    "apiKey": "AIzaSyDLZuCx4P6MNFObb90qDe_X_pX1hO23u6k",
    "authDomain": "dofa-58ee8.firebaseapp.com",
    "projectId": "dofa-58ee8",
    "storageBucket": "dofa-58ee8.appspot.com",
    "messagingSenderId": "198227442409",
    "appId": "1:198227442409:web:b412536545ba0400c30e78"
  },
  "vuefireOptions": {
    "optionsApiPlugin": false,
    "auth": {
      "enabled": true
    },
    "config": {
      "apiKey": "AIzaSyDLZuCx4P6MNFObb90qDe_X_pX1hO23u6k",
      "authDomain": "dofa-58ee8.firebaseapp.com",
      "projectId": "dofa-58ee8",
      "storageBucket": "dofa-58ee8.appspot.com",
      "messagingSenderId": "198227442409",
      "appId": "1:198227442409:web:b412536545ba0400c30e78"
    }
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/opt/build/repo/node_modules/nuxt-seo-ui/dist/runtime/app.config.mjs"

export default /* #__PURE__ */ defuFn(cfg0, inlineConfig)
